import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from '@app/modules/table/table.module';
import { MaybeCurrencyPipe } from '@app/pipes';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import { Services } from '@offer-letter/services';
import { Views } from '@offer-letter/views';
import { CandidateFormsModule } from './forms/candidate-forms.module';
import { OfferLetterResolver } from './offer-letter.resolver';
import { OfferLetterRouterModule } from './offer-letter.routes';

@NgModule({
    declarations: [...Views],
    imports: [
        CommonModule,
        OfferLetterRouterModule,
        AppCommonModule,
        PlatformModule,
        FormsModule,
        TableModule,
        CandidateFormsModule,
    ],
    providers: [...Services, OfferLetterResolver, MaybeCurrencyPipe],
})
export class OfferLetterModule {}
